import { BooleanSelection as BooleanSelectionType } from '../../../../../../types/Survey/Element'
import { BooleanSelection as BooleanSelectionAnswerType } from '../../../../../../types/Survey/Analysis/Element'
import { Props } from './types'
import Core from './Core'
import Pie, { Item as PieItem } from '../../../../../UI/Chart/Pie/Pie'
import { blue, gray } from '../../../../../UI/Chart/colors'
import { ChartType } from './ChartSelector'
import { useState } from 'react'

const BooleanSelection: React.FC<Props<BooleanSelectionType, BooleanSelectionAnswerType> & { small?: boolean }> = ({
  element,
  analysisElement,
  small = false,
}) => {
  const [activeChart, setActiveChart] = useState(ChartType.PIE)

  const getPieChartItems = (): PieItem[] => {
    return [
      {
        label: element.yesLabel,
        value: analysisElement.yesPercentage,
        ...blue,
      },
      {
        label: element.noLabel,
        value: analysisElement.noPercentage,
        ...gray,
      },
    ]
  }

  return (
    <div className="w-full">
      <Core element={element} activeChart={activeChart} setActiveChart={setActiveChart} small={small} />
      <div className={`flex justify-center ${small ? 'mt-3' : 'mt-5'}`}>
        <div className="w-full">
          <Pie items={getPieChartItems()} enableDownload />
        </div>
      </div>
    </div>
  )
}

export default BooleanSelection
